import breakhead from '../../assets/breakhead.png';
import { Milestone } from '../../interfaces/progress';

type Props ={
    item: Milestone
}
const Alerts = ({item}: Props) => {
    return (
        <div className="custom-font">
            <p style={{color: "#778381"}}><span className="pr-3"><img src={breakhead} alt="" width="40" height="auto"/></span> {item.question}</p>
        </div>
    )
}

export default Alerts
